<template>
	<div>
		<el-card class="box-card" :label="title" shadow="hover">
			<div slot="header" class="clearfix">
				<span>{{title}}</span>
			</div>
			<div v-for="(i, idx) in setlist" style="margin-top:-20px">
				<div v-if="i.controltype == 'table'">
					<tableui
						ref="cargo"
						editcell="0"
						:tableData="i.cargolist"
						:columns="columns"
						:gridheight="gridheight"
						emptytext="请添加商品"
					></tableui>
				</div>
			</div>
			<div style="text-align:right;">
				<el-form :inline="true" label-width="100">
					<el-form-item v-for="(item,index) in countlist" :key="index" :label="item.title">
						<span style="margin-right:10px">{{item.value}}</span>
					</el-form-item>
				</el-form>
			</div>
		</el-card>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import tableui from '@/components/table/tablegrid.vue';
export default {
	components: {
		tableui
	},
	props: {
		title:{
			type: String,
			default:''
		},
		l_mode:{
			type: String,
			default:''
		},
		gridheight: {
			type: String,
			default: '100px'
		}
	},
	data() {
		return{
			setlist:[],
			orderinfo:{},
			isdetail:false,
			cargorow:[],
			columns:[],
			countlist:[]
		};
	},
	mounted() {
		
	},
	methods:{
		init(param){
			if(param.orderinfo!=undefined)
				this.orderinfo=param.orderinfo;
			if(param.isdetail!=undefined)
				this.isdetail=param.isdetail;
			this.GetPageLayOut();
		},
		GetPageLayOut(){
			var that = this;
			this.$apipost.get.GetPagecolSet({ syscol:'', l_mode: this.l_mode }).then(res => {
				if (res.length > 0) {
					that.setlist.splice(0, 0, res[0]);
					that.columns = JSON.parse(JSON.stringify(res[0].table));
					that.columns.forEach(e=>{
						e.type='text';
					});
					that.setcargocol(res[0].table);
					//debugger
					that.setpagelayout();
				}
			}).catch(e=>{
				that.GetPageLayOut();
			});
		},
		setcargocol(colset) {
			var cargo = '';
			colset.forEach(e => {
				if (e.type != 'template') {
					cargo += '"' + e.field + '":"",';
				}
			});
			if (cargo != '') {
				cargo = cargo.substring(0, cargo.length - 1);
			}
			cargo = '[{' + cargo + '}]';
			this.cargorow = JSON.parse(cargo)[0];
		},
		//设置页面数据
		setpagelayout() {
			var that = this;
			var colass='';
			var cargolist=[];
			this.orderinfo.list.forEach(e=>{
				that.setlist.forEach(s => {
					if (s.controltype == 'table') {
						colass=s.colass;
						s.cargolist = e.cargolist;
						cargolist=cargolist.concat(e.cargolist);
						return false;
					}
				});
			});
			//计算总金额
			if(colass!='')
			{
				colass=JSON.parse(colass);
				for(var i in colass){
					var amount=0;
					if(colass[i]=='price*num'){
						cargolist.forEach(e=>{
							amount+=parseInt(e.num)*parseFloat(e.price);
						});
					}
					if(colass[i]=='outprice*num'){
						cargolist.forEach(e=>{
							amount+=parseInt(e.num)*parseFloat(e.outprice);
						});
					}
					if(colass[i]=='taxprice*num'){
						cargolist.forEach(e=>{
							amount+=parseInt(e.num)*parseFloat(e.taxprice);
						});
					}
					that.countlist.push({title:i,value:amount.toFixed(2)});
				}
			}
		}
	}
}	
</script>

<style>
</style>
